<template>
  <el-dialog :title="title" :visible.sync="visible"  :close-on-click-modal="false" @opened="openFun">
    <el-tabs v-model="activeTab" type="card" class="tab-container">
      <el-tab-pane label="订单信息" name="orderInfo">
        <p>订单页面</p>
      </el-tab-pane>
      <el-tab-pane label="审批记录" name="flowRecord">
        <order-flow-record ref="recordView" :order-no="orderNo"></order-flow-record>
      </el-tab-pane>
    </el-tabs>
    <span slot="footer">
      <el-button type="primary" :loading="isLoading" @click="closeDialog">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import OrderFlowRecord from "@/views/approval/task/orderFlowRecord.vue";

export default {
  name: "OrderAuditInfo",
  components: {OrderFlowRecord},
  props: {
    dialogVisible: {
      type: Boolean,
      require: true,
      default: false
    },
    orderNo: {
      type: String,
      require: true,
      default: ''
    }
  },
  computed: {
    visible: {
      get: function () {
        return this.dialogVisible
      },
      set: function (val) {
        this.$emit('update:dialogVisible', val)
      }
    }
  },
  data() {
    return {
      title: '查看订单信息',
      isLoading: false,
      activeTab: 'orderInfo',
      entity: {
        id: null,
        name: '',
        description: ''
      },
      options: []
    }
  },
  methods: {
    openFun() {
      this.$refs.recordView.getRecordData()
    },
    closeDialog() {
      this.visible = false
    }
  }
}
</script>

<style scoped>
.tab-container {
  padding: 0 20px;
}
.tab-container :deep(.el-tabs__content) {
  height: auto;
  padding-left: 30px;
  padding-right: 30px;
  overflow-y: auto;
}

</style>
